import { CustomModal, Header } from "./style";
import useModal from "../../hooks/useModal";
import { FaSync } from "react-icons/fa";
import { Button } from "antd";
import useTriggerJob from "../../hooks/useTriggerJob";
import { showError, showSuccess } from "infra/helpers/alerta";

export default function ConfirmRunJobModal() {
  const { isSyncingJobs, setIsSyncingJobs, id } = useModal();

  const { mutate: triggerJob, isLoading: isLoadingTriggerJob } =
    useTriggerJob();

  const handleTriggerJob = () => {
    triggerJob(
      { recurringJobGroupId: id ?? "" },
      {
        onSuccess: () => {
          showSuccess("Jobs sincronizados com sucesso");
          setIsSyncingJobs(false);
        },
        onError: () => {
          showError("Erro ao sincronizar jobs");
        },
      },
    );
  };

  return (
    <CustomModal
      visible={isSyncingJobs}
      onCancel={() => setIsSyncingJobs(false)}
      footer={
        <>
          <Button
            type="primary"
            onClick={handleTriggerJob}
            style={{ borderRadius: 8 }}
            size="large"
            loading={isLoadingTriggerJob}
            disabled={isLoadingTriggerJob}
          >
            Sincronizar
          </Button>
          <Button
            type="default"
            onClick={() => setIsSyncingJobs(false)}
            style={{ borderRadius: 8 }}
            size="large"
            loading={isLoadingTriggerJob}
            disabled={isLoadingTriggerJob}
          >
            Cancelar
          </Button>
        </>
      }
      title={
        <Header>
          <FaSync size={24} color="#fff" /> Sincronizar Jobs
        </Header>
      }
    >
      <p>Deseja realmente sincronizar os jobs?</p>
    </CustomModal>
  );
}
